import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { FileSymlink } from "lucide-react";

import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";
import { PdfModalPip } from "@/components/pdf-modal-pip";
import { IconButton } from "@/components/ui/icon-button";

/**
 * Opens the source document page that a packet page was copied from. Renders
 * nothing for revisions that are not packets (whole-document job sources).
 */
export function PacketSourceSheetButton({
  revisionId,
  pageNumber,
}: {
  revisionId: Id<"projectDocumentRevisions"> | undefined;
  pageNumber: number;
}) {
  const [open, setOpen] = useState(false);
  const { data: packet } = useQuery(
    convexQuery(
      api.projectDocumentPackets.listPacketPageSources,
      revisionId ? { revisionId } : "skip"
    )
  );
  const page = packet?.pages.find((candidate) => candidate.packetPageNumber === pageNumber);
  const source = page && packet?.sources.find((candidate) => candidate.revisionId === page.sourceRevisionId);
  if (!page || !source) return null;

  return (
    <>
      <IconButton
        label={`Open source sheet (${source.documentName}, page ${page.sourcePageNumber})`}
        icon={FileSymlink}
        tooltipSide="bottom"
        onClick={() => setOpen(true)}
      />
      <PdfModalPip
        open={open}
        onOpenChange={setOpen}
        sourcePdf={{ fileUrl: source.fileUrl, filename: source.filename }}
        sourceId={String(source.revisionId)}
        initialPage={page.sourcePageNumber}
      />
    </>
  );
}
